import { store } from '../../configureStore';
import * as constants from './constants';
import { redirectTo } from '../../redirection';
import { getSession } from '../../components/common/Helpers/index';

export const updateProgressStep = (progressStep, action) => {
  if (progressStep) {
    store.dispatch({ type: `UPDATE_${progressStep?.toUpperCase()}`, response: action });
  }
  updateCurrentView(progressStep);
};

export const updateCurrentView = (currentView, history) => {
  const { processSteps } = store.getState();
  const orderSubmitted = getSession('OrderSubmitted');
  let curView = {};
  if (processSteps && Object.keys(processSteps).length > 0) {
    Object.keys(processSteps).forEach((view) => {
      if (view?.toLowerCase() === currentView?.toLowerCase()) {
        curView = processSteps[view];
        return true;
      }
      return false;
    });
  }
  store.dispatch({ type: constants.UPDATE_CURRENT_VIEW, response: curView });
  if (history && curView?.nextViewPage) redirectTo(curView.nextViewPage, history);
  if (orderSubmitted === 'Y' && curView?.currentStep) redirectTo(`${curView.currentStep.toLowerCase()}.html`, history);
};
